import { useMemo } from "react";
import { IProject } from "api/project";
import { IHackathonResponse } from "api/hackathon";

export const useProjectEditStep = (
  project?: IProject,
  hackathon?: IHackathonResponse,
  status_inprogess?: "draft" | "submit" | "pending"
) => {
  return useMemo(() => {
    const passOverview = !!project?.name && !!project?.tagLine;
    let passDetail =
      !!project?.description &&
      !!project?.technology &&
      project?.technology?.length > 0;

    if (hackathon?.submission?.custom?.requireVideos === "on") {
      passDetail = passDetail && !!project?.linkVideoDemo;
    }

    let passAdditionInfo = true;
    // const customFormQuestion = hackathon?.submission?.customFormQuestion;
    // if (hackathon?.submission?.custom?.fileUpload?.require) {
    //   passAdditionInfo = !!project?.submission_project?.fileUpload;
    // }

    // // if passAdditionInfo still true => check form required
    // if (
    //   passAdditionInfo &&
    //   customFormQuestion &&
    //   customFormQuestion?.length !== 0
    // ) {
    //   // get required field id
    //   const requiredFieldIds = customFormQuestion
    //     ?.filter((x) => x.isRequire)
    //     ?.map((x) => x._id);

    //   const passedQuestions =
    //     project?.submission_project?.customFormQuestion?.filter((x) => {
    //       return requiredFieldIds?.includes(x._id);
    //     });
    //   passAdditionInfo = passedQuestions?.length === requiredFieldIds?.length;
    // }

    // const haveAdditionalStep =
    //   (customFormQuestion && customFormQuestion?.length !== 0) ||
    //   hackathon?.submission?.custom?.fileUpload?.active;

    const isSubmitted =
      status_inprogess === "submit" ||
      project?.hackathonIds.find((x) => x._id === hackathon?._id)
        ?.status_inprogess === "submit";

    const status =
      status_inprogess ||
      project?.hackathonIds.find((x) => x._id === hackathon?._id)
        ?.status_inprogess;

    let passCount = 0;
    // let totalCount = haveAdditionalStep ? 4 : 3;
    let totalCount = 4;
    const passManageTeam = project?.skipTeammate;
    if (passManageTeam) passCount += 1;
    if (passOverview) passCount += 1;
    if (passDetail) passCount += 1;
    // if (haveAdditionalStep && passAdditionInfo) passCount += 1;
    if (isSubmitted) passCount += 1;

    return {
      passManageTeam,
      passOverview,
      passDetail,
      passAdditionInfo,
      isPassAll: passOverview && passDetail && passAdditionInfo,
      isSubmitted,
      status,
      passCount,
      totalCount,
    };
  }, [project, hackathon]);
};
